module.exports = __webpack_public_path__ + "media/icons/lock-305865fd.png";